import React from 'react';
import HelpContent from './HelpContent';
import standardRendimiento from 'img/standard_rendimiento.png';
import proyeccionRendimiento from 'img/proyeccion_rendimiento.png';

const ElectrificacionACSResidencialHelp = () => (
  <HelpContent>
    <h1>
      Electrificación de agua caliente sanitaria (ACS) en sector residencial
    </h1>
    <p>
      Esta medida evalúa el impacto de la electrificación del agua caliente sanitaria (ACS) en el sector residencial reemplazando el uso de  gas natural o gas licuado.
    </p>
    <p>
      <strong>Trayectoria 1:</strong> en el año 2035 aumenta en 1%  la participación de electricidad para uso de ACS (7% en total) y un aumento del 56% en 2050, alcanzando un 62% de participación.
    </p>

  </HelpContent>
);

export default ElectrificacionACSResidencialHelp;
